import styled from 'styled-components';
import { ImageUtils } from '../../utils/ImageUtils';

export const NumberTicket = ({ cnt }: { cnt: number }) => {
  return (
    <TicketContainer>
      <Ticket src={ImageUtils.CardMain} />
      <TicketTextContainer>
        <Inner>
          <Title>오프라인 이벤트 참가 정보</Title>
          <NumberTitleContainer>
            <NumberTitle>참가자 번호</NumberTitle>
          </NumberTitleContainer>
          <TicketText>{cnt}</TicketText>
        </Inner>
      </TicketTextContainer>
    </TicketContainer>
  );
};

const Title = styled.h3`
  font-weight: 800;
  text-align: center;
  letter-spacing: -0.02em;

  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 9px;

  margin-top: 0;
  font-size: 16px;
  line-height: 16px;
`;

const NumberTitleContainer = styled.div`
  margin: 0 auto;

  background: rgba(0, 0, 0, 0.1);
  border-top: 1px solid #000000;

  width: 215px;
  height: 32px;
`;

const NumberTitle = styled.h4`
  font-weight: 800;
  text-align: center;
  letter-spacing: -0.02em;
  color: #000000;

  font-size: 16px;
  line-height: 29px;
`;

const Ticket = styled.img`
  position: relative;
`;

const TicketContainer = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 12px;
`;

const TicketTextContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Inner = styled.div`
  border-bottom: 1px solid #000000;
`;

const TicketText = styled.p`
  font-weight: bold;
  font-weight: 700;
  color: #000000;
  text-align: center;

  font-size: 80px;
  line-height: 86px;
  padding-bottom: 5px;
`;
